import type { ConfigApi } from '@backstage/frontend-plugin-api';

export const LEGACY_GUEST_TOKEN_KEY = 'enableLegacyGuestToken';
export const SIGN_IN_PROVIDER_KEY = '@backstage/core:SignInPage:provider';
export const ACTIVE_AUTH_PROVIDER_KEY =
  'c4ci.factory-portal:active-auth-provider';
export const FETCH_ERROR_MARKERS = [
  'Could not fetch catalog entities',
  'Failed to load entity kinds',
  'TypeError: Failed to fetch',
];

export function isBrowser(): boolean {
  return typeof window !== 'undefined';
}

export function hasKeycloakProvider(configApi: ConfigApi): boolean {
  return (
    configApi.has('auth.providers.oidc') ||
    configApi.has('auth.providers.oidc.development.clientId') ||
    configApi.has('auth.providers.oidc.production.clientId')
  );
}

export function hasGuestProvider(configApi: ConfigApi): boolean {
  const authEnvironment = configApi.getOptionalString('auth.environment');
  if (authEnvironment === 'production') {
    return false;
  }

  return true;
}

export function isGuestProviderSelected(): boolean {
  return (
    isBrowser() &&
    window.localStorage.getItem(SIGN_IN_PROVIDER_KEY) === 'guest'
  );
}

export function hasGuestSessionHint(): boolean {
  return (
    isBrowser() &&
    window.localStorage.getItem(ACTIVE_AUTH_PROVIDER_KEY) === 'guest'
  );
}

export function markGuestSessionActive() {
  if (!isBrowser()) {
    return;
  }

  window.localStorage.setItem(ACTIVE_AUTH_PROVIDER_KEY, 'guest');
}

export function clearGuestSessionHint() {
  if (!isBrowser()) {
    return;
  }

  window.localStorage.removeItem(ACTIVE_AUTH_PROVIDER_KEY);
}

export function clearLegacyGuestFallbackState() {
  if (!isBrowser()) {
    return;
  }

  if (window.localStorage.getItem(LEGACY_GUEST_TOKEN_KEY) === 'true') {
    window.localStorage.removeItem(LEGACY_GUEST_TOKEN_KEY);
    if (window.localStorage.getItem(SIGN_IN_PROVIDER_KEY) === 'guest') {
      window.localStorage.removeItem(SIGN_IN_PROVIDER_KEY);
    }
  }
}

export function clearStoredGuestSelection() {
  if (!isBrowser()) {
    return;
  }

  window.localStorage.removeItem(LEGACY_GUEST_TOKEN_KEY);
  if (window.localStorage.getItem(SIGN_IN_PROVIDER_KEY) === 'guest') {
    window.localStorage.removeItem(SIGN_IN_PROVIDER_KEY);
  }
  clearGuestSessionHint();
}

export function hasVisibleFetchError(): boolean {
  if (!isBrowser()) {
    return false;
  }

  const bodyText = document.body?.innerText ?? '';
  return FETCH_ERROR_MARKERS.some(marker => bodyText.includes(marker));
}
